import { render } from "./MaterialsList.vue?vue&type=template&id=e7e0d70e&lang=pug"
import script from "./MaterialsList.vue?vue&type=script&lang=js"
export * from "./MaterialsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__